module.exports = __webpack_public_path__ + "static/media/logo.1b35355e.png";